/*jshint esversion: 6 */
/*jshint sub:true*/
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  client: { id: 0, name: '', base_uri: '', identifier: '', callbacks: [], projects: [], query_string: '' },
  procoreclient: { id: 0, name: '', base_uri: '', identifier: '', secret: '', query_string: '' },
  callback: { id: 0, callback_uri: '', callback_http_method: 'POST', takt_entity: 'TWorkPackage', takt_http_method: 'POST', user_action: { text: '', value: '' } },
  user_clients: {},
  error: ''
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getUserClients: (state) => state.user_clients,
  isLoading: (state) => state.loading
};
// Actions
const actions = {
  setClientValue({commit}, payload){
    commit('set_client_value', payload);
  },
  setProcoreClientValue({commit}, payload){
    commit('set_procoreclient_value', payload);
  },
  setCallbackValue({commit}, payload){
    commit('set_callback_value', payload);
  },
  addClientToBusiness({commit, rootState}, payload){
    commit('add_client_to_business', {rootState: rootState, payload: payload});
  },
  requestUserClients({commit}){
    return new Promise((resolve, reject) => {
      axios({
        url: 'clients?show=showWithEntities',
        method: 'GET',
        headers: { 'cache-control': 'no-cache' }
      })
      .then(resp => {
        commit('set_user_clients', resp.data.data);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  createClient({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: 'clients',
        method: 'POST',
        data: payload.payload
      })
      .then(resp => {
        commit('add_client', resp.data.data);
        resolve();
      })
      .catch(err => {
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject(err);
      });
    });
  },
  deleteClient({commit}, payload){
    axios({
      url: 'clients/' + payload.client_id,
      method: 'DELETE'
    })
    .then(() => {
      commit('remove_client', { client_id: payload.client_id });
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  updateClient({commit}, payload){
    axios({
      url: 'clients/' + payload.client_id,
      method: 'PUT',
      data: payload.data
    })
    .then(() => {
      commit('update_client', payload);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  createCallback({commit}, payload){
    axios({
      url: 'clients/' + payload.client_id + '/callbacks',
      method: 'POST',
      data: payload.payload
    })
    .then(resp => {
      commit('add_callback', { client_id: payload.client_id, callback: resp.data.data });
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  deleteCallback({commit}, payload){
    axios({
      url: 'clients/' + payload.client_id + '/callbacks/' + payload.callback_id,
      method: 'DELETE'
    })
    .then(() => {
      commit('remove_callback', { client_id: payload.client_id, callback_id: payload.callback_id });
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  updateCallback({commit}, payload){
    axios({
      url: 'clients/' + payload.client_id + '/callbacks/' + payload.callback_id,
      method: 'PUT',
      data: payload.data
    })
    .then(() => {
      commit('update_callback', payload);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  removeClientFromProject({commit, rootState}, payload){
    axios({
      url: 'clients/' + payload.client_id + '/removeprojects',
      method: 'PUT',
      data: payload.payload
    })
    .then(() => {
      commit('remove_client_from_project', { rootState: rootState, payload: {client_id: payload.client_id, payload: payload.payload} });
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  addClientToProjects({commit, rootState}, payload){
    axios({
      url: 'clients/' + payload.client_id + '/addprojects',
      method: 'PUT',
      data: payload.payload
    })
    .then(() => {
      commit('add_client_to_project', { rootState: rootState, payload: {client_id: payload.client_id, payload: payload.payload} });
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  // addClientToBusiness({commit}, payload){
  //   axios({
  //     url: 'clients/' + payload.client_id + '/addbusiness',
  //     method: 'PUT',
  //     data: {}
  //   })
  //   .then((resp) => {
  //     commit('add_business', {client_id: payload.client_id, business: resp.data.data});
  //   })
  //   .catch(err => {
  //     commit('set_error', extractErrorDetails(err));
  //   });
  // }
};
// Mutations
const mutations = {
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_client_value(state, payload){
    Object.assign(state.client, payload)
  },
  set_procoreclient_value(state, payload){
    Object.assign(state.procoreclient, payload)
  },
  set_callback_value(state, payload){
    Object.assign(state.callback, payload)
  },
  set_error(state, err){
    state.error = err;
  },
  add_client_to_business(state, {rootState, payload}){
    rootState.Ultra.businesses[payload.business_id].clients.push(payload.client_id);
  },
  set_user_clients(state, user_clients){
    state.user_clients = [...user_clients];
  },
  add_callback(state, payload){
    const index = state.user_clients.findIndex(function(item) {
      return item.id == payload.client_id;
    });
    state.user_clients[index].callbacks.push(payload.callback);
  },
  add_client(state, client){
    state.user_clients.push(client);
  },
  remove_callback(state, payload){
    const client_index = state.user_clients.findIndex(function(item) {
      return item.id == payload.client_id;
    });
    const callback_index = state.user_clients[client_index].callbacks.findIndex(function(item) {
      return item.id == payload.callback_id;
    });
    state.user_clients[client_index].callbacks.splice(callback_index, 1);
  },
  remove_client(state, payload){
    const client_index = state.user_clients.findIndex(function(item) {
      return item.id == payload.client_id;
    });
    state.user_clients.splice(client_index, 1);
  },
  update_client(state, payload){
    const client_index = state.user_clients.findIndex(function(item) {
      return item.id == payload.client_id;
    });
    Object.assign(state.user_clients[client_index], payload.data);
  },
  update_callback(state, payload){
    const client_index = state.user_clients.findIndex(function(item) {
      return item.id == payload.client_id;
    });
    const callback_index = state.user_clients[client_index].callbacks.findIndex(function(item) {
      return item.id == payload.callback_id;
    });
    Object.assign(state.user_clients[client_index].callbacks[callback_index], payload.data);
  },
  add_client_to_project(state, {rootState, payload}){
    for (let index = 0; index < payload.payload.projects.length; index++) {
      rootState.Ultra.clients[payload.client_id].projects.push(payload.payload.projects[index].id);
    }
  },
  remove_client_from_project(state, {rootState, payload}){
    for (let index = 0; index < payload.payload.projects.length; index++) {
      const project_index = rootState.Ultra.clients[payload.client_id].projects.findIndex(function(project_id){
        return project_id == payload.payload.projects[index].id;
      });
      rootState.Ultra.clients[payload.client_id].projects.splice(project_index, 1);
    }
  },
  add_business(state, payload){
    const client_index = state.user_clients.findIndex(function(item) {
      return item.id == payload.client_id;
    });
    state.user_clients[client_index].business = payload.business;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
